import { Button, FormControl, Grid } from "@mui/material";
import React, { useState } from "react";
import CustomSelect from "../Select/CustomSelect";
import CommonDescription from "../CommonDescription";

const dropdownDetails = [
  {
    name: "reason",
    label: "Select reason",
    placeholder: "Select",
  },
];
const options = ["Documents awaited", "Petition not uploaded", "Query raised"];

const ReasonModal = ({
  dropdownLabel = dropdownDetails,
  reasons = options,
  buttonLabel = "Submit",
  isSubmitActive = false,
  submitHandler = () => {},
}) => {
  const [selectValue, setSeletedValue] = useState("");
  const [inputText, setInputText] = useState("");
  const onClickHandler = (selectValue, inputText) => {
    submitHandler(selectValue, inputText?.trim());
  };
  const inputChangeHandler = (e) => {
    setInputText(e?.target?.value);
  };
  return (
    <Grid
      sx={{
        padding: "0px",
        margin: "0px",
        width: "100%",
        height: "100%",
      }}
    >
      <Grid item xs={12}>
        <FormControl sx={{ width: "100%" }}>
          <Grid container spacing={0}>
            {dropdownLabel?.map((item, index) => (
              <Grid
                item
                xs={12}
                sx={{
                  paddingTop: index === 0 ? "unset" : "1rem",
                }}
              >
                <CustomSelect
                  label={item?.label}
                  placeholder={item?.placeholder}
                  customSelectValue={selectValue}
                  name={item?.name}
                  options={reasons}
                  handleChange={(e) => setSeletedValue(e?.target?.value)}
                  height="4.4rem"
                  border="1px solid rgba(0,0,0,0.12)"
                  labelStyles={{
                    fontSize: "1.3rem",
                    fontWeight: 500,
                    color: "#070A13",
                    marginBottom: "5px",
                    fontStyle: "Inter",
                  }}
                  menuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: "calc(100% - 68%)",
                      },
                    },
                  }}
                />
              </Grid>
            ))}
            <div style={{ width: "100%" }}>
              <CommonDescription
                minRows={6}
                heading="Remarks"
                placeholder="Enter"
                onChange={inputChangeHandler}
                isSubmitActive={
                  selectValue?.length && inputText?.trim()?.length
                }
                onSubmitButton={() => onClickHandler(selectValue, inputText)}
                descriptionVal={inputText}
              />
            </div>
          </Grid>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ReasonModal;
